<template>
    <div class="scheduler">
        <h4 class="headline" v-if="current_datetime">Today is {{ current_datetime.toDateString() }}</h4>
        <br>
        <p class="text-center">Duration: {{ getDuration(limited_update_rule.length_of_run_minutes) }} <p/>
        <br>
        <div class="time_item" :class="{'unavailable': !time.available, 'selected': time.selected}" @click="selectTime(time)" v-for="time in times">
            <h1>{{ prettyString(time.string_time) }}<small>{{ getTimeOfDay(time.string_time) }}</small></h1>
            <br>
            <p>{{ getStringMonth(time.string_time) }}<br> {{ time.string_time.getDate() }}<p/>
        </div>
    </div>
</template>

<script>
  import {mapState} from 'vuex'

  export default {
    name: 'Scheduler',
    data () {
      return {
        current_datetime: '',
        times: [],
        value: this.defaultValue || null
      }
    },
    props: ['settings', 'defaultValue', 'options'],
    async created () {
      await this.$store.dispatch('loadScheduled', this.$route.params.advertisement_id);
      await this.$store.dispatch('loadUpdateRuleLimited', this.ad.update_rule_id);
      this.current_datetime = new Date();

      let selection_limits = 16;
      let length = this.limited_update_rule.length_of_run_minutes;
      let rolling_date = this.getNearestTimeRounded(this.current_datetime, length);
      for (var i = 0; i < selection_limits; i++) {
        this.times.push({
          start_time: rolling_date.toUTCString(),
          iso_string: rolling_date.toISOString(),
          string_time: rolling_date,
          duration: length,
          available: true,
          selected: false
        });
        rolling_date = this.addMinutes(rolling_date, length)
      }

      this.times.forEach(time => {
        if (this.scheduled.includes(time.iso_string)) {
          time.available = false;
        }
      })
    },
    methods: {
      getTimeOfDay(date) {
        var hours = new Date(date).getHours();
        var ampm = (hours >= 12) ? 'PM' : 'AM';
        return ampm
      },
      addMinutes(date, minutes) {
        var newDateObj = new Date();
        newDateObj.setTime(date.getTime() + (minutes * 60 * 1000));
        return newDateObj;
      },
      prettyString(date) {
        let temp_date = new Date(date);
        let hours = ((temp_date.getHours() % 12));
        if (hours == 0) hours = 12;
        temp_date.setHours(hours);
        return temp_date.toTimeString().match(/[0-9][0-9]:[0-9][0-9]/)[0]
      },
      selectTime (time) {
        if (!time.available) return;
        this.times.forEach(item => { item.selected = false });
        time.selected = true;
        this.value = time.start_time;
      },
      getNearestTimeRounded(time, length) {
        let minutes = time.getMinutes();
        let round_by;
        if ((length / 30) % 2 === 0) {
          round_by = 0;
        } else {
          round_by = 30;
        }
        let round_to;
        if (minutes <= 30 && round_by == 30) {
          round_to = 30;
        } else {
          round_to = 60;
        }
        let difference = round_to - minutes;
        time.setMinutes(time.getMinutes() + difference);
        time.setSeconds(0);
        time.setMilliseconds(0);
        return time
      },
      update(value){
        this.$emit('input', value);
      },
      getStringMonth (date) {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        return months[date.getMonth()]
      },
      getDuration (minutes) {
        let hours = minutes / 60;
        if (hours > 24) {
          return (hours / 24) + ' days';
        } else {
          return hours + ' hours';
        }
      }
    },
    computed: {
      ...mapState(['scheduled', 'limited_update_rule']),
      ...mapState('advertisements', {
        ad: 'single_ad'
      })
    },
    watch: {
      value(newVal){
        this.update(newVal);
      }
    }
  }
</script>

<style scoped>
    .headline {
        text-align: center;
    }
    .time_item {
        cursor: pointer;
        width: 50px;
        height: 60px;
        border: 1px solid #1f5ee6;
        border-radius: 3px;
        text-align: center;
        padding: 10px;
        display: inline-block;
        margin: 2px;
        overflow: hidden;
    }
    .unavailable {
        background: rgb(210,210,210);
        border: 1px solid transparent;
        cursor: default;
    }
    small {
        font-size: 12px;
    }
    h1 {
        margin-left: -5px;
        font-size: 18px;
    }
    .scheduler {
        margin: auto;
        text-align: center;
    }
    .text-center {
        text-align: center;
    }
    .time_item:hover {
        background: rgb(210,210,210);
    }
    .selected {
        border: 1px solid #1b5e20;
        background: rgba(110,210,110, .5);
    }
</style>



// WEBPACK FOOTER //
// src/components/configurator/Scheduler.vue